export default {
  SHOW: '@WS_EDITOR/PREVIEW_MODE/SHOW',
  HIDE: '@WS_EDITOR/PREVIEW_MODE/HIDE',
};
